import { ReactionSetUsedSampleVolume } from './../reaction-set/redoorcancel-reactionset-request';
import { ReactionSetRequestDTO } from './models/ReactionSetRequestDTO';
import { SampleAndPrimerResponseDTO } from './models/SampleAndPrimerResponseDTO';
import { SelectableLab } from './../carrier/selectable-lab';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Order, OrderItem, SequencingPrimer, Comment } from './models/order';
import { OrderListService } from './order-list.service';
import { ErrorHandler } from '../utils/error-handler';
import { MessagesService } from '../messages/messages.service';
import { LazyLoadEvent } from 'primeng/components/common/lazyloadevent';
import { OrderStatusUpdateRequest } from './models/order-status-update-request';
import { CarrierState } from '../masterdata/models/carrierState';
import { Printer } from '../masterdata/models/printer';
import { CarrierStatusService } from '../carrier-status/carrier-status.service';
import { ProcessStep } from '../masterdata/models/processStep-enum';
import { OrderPrintBarcode } from './models/orderPrintBarcode';
import { SamplePrintTemplate } from './models/SamplePrintTemplate';
import { SelectItem } from 'primeng/components/common/selectitem';

import { ReactionSetService } from '../reaction-set/reaction-set.service';
import { ReactionsManagerDTO } from './models/reactionsManagerDTO';
import { OrderCommentsUpdateRequest } from './models/order-comments-update-request';
import { RedoCancelReactionSetRequest, ReactionSetProtocol } from '../reaction-set/redoorcancel-reactionset-request';
import { ConfirmationService, Message } from 'primeng/api';


import { PlateUsageOrderData } from './models/PlateUsageOrderData';
import { CancelOrderItemRequest } from './models/cancelOrderItemRequest';
import { RushFlagUpdateRequest } from './models/RushFlagUpdateRequest';
import { QualityreportListService } from '../qualityreport-list/qualityreport-list.service';
import { QCReportFilter } from '../qualityreport-list/models/QualityReport';
import { QcReportDetailDTO, EurofinsControlParamsDTO } from '../qcreport-detail/qcReportmodel';
import { QcreportDetailService } from '../qcreport-detail/qcreport-detail.service';
import { CarrierSearchService } from '../carrier-search/carrier-search.service';
import { Container } from '../container-view/models/container';
import { ContainerType } from '../container-view/models/container-type-enum';
import { ScanableMaterial } from './models/ScanableMaterial';
import { MaterialType } from '../carrier/carrier-enum';
import { QCOverRuleUpdateRequest } from './models/QcOverruleUpdateRequest';
import { OriginalMaterialType } from '../carrier/sample';
import { NxpUkUpdateRequest } from './models/NxpUkUpdateRequest';
import { DxPUpdateRequest } from './models/DxPUpdateRequest';
import { MaterialResponsePerOrder } from './models/material-response-per-order';



@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.css']
})
export class OrderListComponent implements OnInit {
  @Input() displayDialog: boolean;
  @Output() updatedDisplayDialog = new EventEmitter();
  @Input() isSearchOrder: boolean;
  orders: Order[];
  @Input() selectedOrder: Order;
  cols: any[];
  order = new Order();
  headerColumns: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  headerRows: string[] = ["A", "B", "C", "D", "E", "F", "G", "H"];
  selectedLab: SelectableLab;
  totalRecords: number = 0;
  loading: boolean;
  errorHandler: ErrorHandler = new ErrorHandler;
  selectedPlate: OrderItem[] = [];
  selectedPrimer: SequencingPrimer[] = [];
  partialReceivedActive: boolean;
  orderItemDisabledChecked: OrderItem[] = [];
  sequencingPrimerDisabledChecked: SequencingPrimer[] = []
  orderItemChecked: OrderItem[] = [];
  samplesIds: Array<string> = [];
  primersIds: Array<string> = [];
  processStep: string;
  carrierStateDetails: CarrierState;
  platePrintersList: Printer[];
  tubePrintersList: Printer[];
  selectedPlatePrinter: Printer;
  selectedTubePrinter: Printer;
  selectedDefaultPrinter: Printer;
  isPrinterLoaded: boolean = false;
  comments: Comment[] = [];
  orderStatusList: SelectItem[];
  reactionsManagerDTO: ReactionsManagerDTO[];
  reactionSetCols: any[];
  index: number = 0;
  enableUpdate: boolean = false;
  plateView: boolean = false;

  supportCategories: SelectItem[] = [];
  internalComment: string;
  selectedSupportCategory: string;
  isInternalCommentUpdateRequested: boolean = false;
  isSupportCategoryUpdateRequested: boolean = false;
  selectedReactionSetsToCancel: Array<string> = [];
  selectedReactionSetsToRepeat: Array<string> = [];
  selectedReactionSetsToUpdateProtocols: Array<ReactionSetProtocol> = [];
  selectedReactionSetsToUpdateVolume: Array<ReactionSetUsedSampleVolume> = [];
  redoCancelReactionSetRequest: RedoCancelReactionSetRequest = new RedoCancelReactionSetRequest();
  blocked: boolean = false;
  msgs: Message[] = [];
  rushFlagUpdateRequest: RushFlagUpdateRequest;
  queryString: string;
  qcOverRuleUpdateRequest: QCOverRuleUpdateRequest;
  nxpUkUpdateRequest: NxpUkUpdateRequest;
  dxpUpdateRequest: DxPUpdateRequest;

  plateUsageOrderData: PlateUsageOrderData;
  sequencingPrimerCheck: SequencingPrimer[] = [];
  reactionOptionProtocolsList: SelectItem[];

  qcReports: QcReportDetailDTO[];
  displayQCReportDialog: boolean = false;
  qcReportDetail: QcReportDetailDTO;
  eurofinsControl: EurofinsControlParamsDTO[] = [];
  id: string;
  qcReportViewMap: Map<string, QcReportDetailDTO[]>;
  selectedContainer: Container;
  isCarrier: boolean;
  expectedMaterials: ScanableMaterial[];
  materialWithoutBarcodeCount = 0;
  receivedMaterials: ScanableMaterial[];
  cacheSavedMaterial = 0;
  noUnsavedEntry: boolean = true;
  materialBarcode: string;
  latestScannedBarcodes: string[] = [];
  cacheReceivedMaterials: ScanableMaterial[];
  isGenerateClicked = false;
  setProtocol: string;
  selectedFilter: string;
  searchedFilterBarcode: string;
  materialResponsePerOrder: MaterialResponsePerOrder[];
  materialscols: any[];
  samplesSelectionList : SelectItem[]=[];
  primersSelectionList : SelectItem[]=[];
  selectedSampleforReaction : OrderItem;
  selectedPrimerforReaction : SequencingPrimer;
  selectableLab: SelectableLab;
  sampleAndPrimerResponseDTO: SampleAndPrimerResponseDTO;
  reactionSetRequestDTO : ReactionSetRequestDTO ;
  usedSampleVolume :number = 0;
  constructor(private orderListService: OrderListService, private messagesService: MessagesService,
    private carrierStatusService: CarrierStatusService, private reactionSetService: ReactionSetService,
    private confirmationService: ConfirmationService, private qualityreportListService: QualityreportListService,
    private qcreportDetailService: QcreportDetailService, private carrierSearch: CarrierSearchService) {
    this.selectedLab = JSON.parse(localStorage.getItem('lab'));
  }

  ngOnInit() {
    this.expectedMaterials = [];
    this.receivedMaterials = [];
    this.cacheReceivedMaterials = [];
    if (this.selectedOrder) {
      this.findExpectedMaterials(this.selectedOrder);
    }
    this.checkRecentUnsavedEntry();
    this.selectedLab = JSON.parse(localStorage.getItem('lab'));

    if (!this.isPrinterLoaded)
      this.getListOfPrinters();
    this.getSampleReceptionDefinition();

    this.cols = [

      { field: 'orderStatus', header: 'Order Status' },
      { field: 'customerName', header: 'Customer Name' }

    ];

    this.orderStatusList = [
      { label: 'All', value: 'ALL' },
      { label: 'New', value: 'New' },
      { label: 'Complete', value: 'COMPLETE' },
      { label: 'Received', value: 'IN_PROCESS' },
      { label: 'Cancel', value: 'CANCEL' }]

    this.reactionOptionProtocolsList = [
      { label: 'GCRich', value: 'GCRich' },
      { label: 'BisulfitSample', value: 'BisulfitSample' },
      { label: 'Standard', value: 'Standard' }
    ]

    this.reactionSetCols = [
      { field: 'id', header: 'id' },
      { field: 'primerName', header: 'primerName' },
      { field: 'quality', header: 'quality' },
      { field: 'state', header: 'state' },
      { field: 'usedSampleVolume', header: 'Used Volume' },
      { field: 'repeat', header: 'repeat' },
      { field: 'cancel', header: 'cancel' },
      { field: 'redoCount', header: 'redoCount' },
      { field: 'reactionOptionProtocol', header: 'reactionOptionProtocol' }
    ];

    this.materialscols = [

      { field: 'materialName', header: 'Material Name' },
      { field: 'receptionDate', header: 'Reception Date' },
    ]

    this.supportCategories.push({ title: 'OK', value: 'OK', icon: 'fa fa-check-circle-o' });
    this.supportCategories.push({ title: 'Leakage', value: 'LEAKAGE', icon: 'fa fa-tint' });
    this.supportCategories.push({ title: 'Barcode', value: 'BARCODE', icon: 'fa fa-barcode' });
    this.supportCategories.push({ title: 'Unhappy', value: 'UNHAPPY', icon: 'fa fa-frown-o' });
    this.supportCategories.push({ title: 'Material Missing', value: 'MATERIAL_MISSING', icon: 'fa fa-hand-lizard-o' });
    this.supportCategories.push({ title: 'Material in GatcLims', value: 'GatcLims', icon: 'fa fa-search' });
  }

  getPaginatedOrders(event: LazyLoadEvent) {

    this.loading = true;
    console.log("Order stat row : " + event.first + " end row: " + (event.first + event.rows))
    this.getOrders(event.first, event.first + event.rows, this.queryString, this.selectedFilter, this.searchedFilterBarcode);
  }

  getOrders(start: number, end: number, queryString: string, selectedFilter: string, searchedFilterBarcode: string) {

    if (this.isSearchOrder == undefined) {

      this.orderListService.getOrders(start, end, queryString, selectedFilter, searchedFilterBarcode).subscribe(

        results => {
          if (!results) {
            return;
          }

          this.orders = results.data;
          this.loading = false;
        },
        error => {
          console.log(error);
          let message = this.errorHandler.handleError(error);
          this.messagesService.addErrorMessage(message);
          this.loading = false;
        }
      );
    }
  }

  countOrders(queryString: string) {

    this.loading = true
    this.orderListService.countOrder(queryString).subscribe(
      results => {
        this.totalRecords = results.data
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    )
  }


  selectOrder(event: Event, order: Order) {
    this.cacheSavedMaterial = 0;
    this.comments = [];
    this.selectedOrder = order;
    console.log("select order", order.id, order.orderId)
    this.displayDialog = true;
    event.preventDefault();

    this.loading = true
    this.orderListService.getOrderView(order.orderId).subscribe(
      results => {
        if (!results && !results.data) {
          return;
        }
        order = results.data;
        this.selectedOrder.orderItems = order.orderItems;
        this.selectedOrder.sequencingPrimers = order.sequencingPrimers;
        /** should be removed once we are not remaining with the materials which exists in BB but processed in GATCLIMS */
        this.selectedOrder.sequencingPrimers.forEach(primer => {
          if (primer.primerType === "Stored" && (primer.storagePlateBarcode === "" || primer.storagePlateBarcode == null || primer.storagePlateBarcode == undefined))
            primer.isPresentInGatcLims = true
        })
        this.checkRecentUnsavedEntry();
        this.findExpectedMaterials(order);
        this.selectedOrder.samplePlateCount = order.samplePlateCount;
        this.selectedOrder.sampleTubeCount = order.sampleTubeCount;
        this.selectedOrder.primerEnclosedCount = order.primerEnclosedCount;
        this.selectedOrder.primerSynthesizedCount = order.primerSynthesizedCount;
        this.selectedOrder.processingOption = order.processingOption;
        this.selectedOrder.isRush = order.isRush;
        this.selectedOrder.isQCOverRule = order.isQCOverRule;
        this.selectedOrder.isDxP = order.isDxP;
        this.selectedOrder.isNxpUk = order.isNxpUk;
        this.selectedOrder.orderConfirmationDate = order.orderConfirmationDate;
        this.selectedOrder.materialReceivedDate = order.materialReceivedDate;
        this.selectedOrder.internalComment = order.internalComment;
        this.selectedOrder.orderRef = order.orderRef
        this.allDisabledSampleCheckBox(this.selectedOrder.orderItems);


        this.allDisabledPrimerCheckBox(this.selectedOrder.sequencingPrimers);
        console.log("results:", this.selectedOrder);
        if (!this.isPrinterLoaded) {
          this.getListOfPrinters();
          this.selectedTubePrinter = null;
          this.selectedPlatePrinter = null;
        }

        this.getSampleReceptionDefinition();

        this.loading = false;
      },
      error => {
        console.log(error);
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.loading = false;
      }
    );
    this.ifNoValidBarcodePresent();
  }

  onDialogHide() {
    this.saveScannedMaterialState()
    document.getElementById("searchOrder").focus()
    this.receivedMaterials = [];
    this.expectedMaterials = []
    this.latestScannedBarcodes = []
    this.cacheSavedMaterial = 0;
    this.materialWithoutBarcodeCount = 0;
    if (this.isSupportCategoryUpdateRequested || this.isInternalCommentUpdateRequested) {
      let commentUpdateRequest: OrderCommentsUpdateRequest = new OrderCommentsUpdateRequest();
      commentUpdateRequest.orderId = this.selectedOrder.orderId;
      commentUpdateRequest.internalComment = this.internalComment;
      commentUpdateRequest.supportCategory = this.selectedSupportCategory;
      this.orderListService.updateSupportComments(commentUpdateRequest).subscribe(
        results => {
          if (!results || !results.data) {
            return;
          }
        },
        error => {
          let message = this.errorHandler.handleError(error);
          this.messagesService.addErrorMessage(message);
          this.loading = false;
        }
      );
    }
    if (this.comments.length > 0) {
      this.orderListService.updateComments(this.comments).subscribe(
        results => {
          console.log("results:", results.data);
          if (results.data) {
            this.messagesService.addSuccessMessage({
              severity: 'success', summary: 'Commnent(s) updated successful',
              detail: 'Commnent(s) updated successful'
            });
          } else {
            this.messagesService.addErrorMessage({
              severity: 'error', summary: 'Failed to update comments',
              detail: 'Failed to update comments'
            });
          }

        },
        error => {
          console.log(error);
          let message = this.errorHandler.handleError(error);
          this.messagesService.addErrorMessage(message);
          this.loading = false;
        }
      );
    }
    this.selectedOrder = null;
    this.internalComment = null;
    this.isInternalCommentUpdateRequested = false;
    this.isSupportCategoryUpdateRequested = false;
    this.selectedSupportCategory = null;
    this.index = 0;
    this.qcReports = null;
    this.updatedDisplayDialog.emit(false);
  }

  cloneOrder(o: Order): Order {
    let order = new Order();
    for (let prop in o) {
      order[prop] = 0[prop];
    }
    return order;
  }

  // loadDataOnScroll(event: LazyLoadEvent) {

  //   console.log(event);
  //   console.log("first: " + event.first + " Rows: " +  event.rows + " Page: " + (event.first/100));
  //   this.pageNo = event.first/100;
  //   this.loading = true;
  //   this.getOrders(this.pageNo);
  // }

  // this method updates order status
  updateOrderStatus() {

    this.loading = true
    console.log(this.selectedOrder.orderId)
    let updateRequest = new OrderStatusUpdateRequest();
    updateRequest.orderId = this.selectedOrder.orderId;

    let lab = JSON.parse(localStorage.getItem('lab'));
    updateRequest.labId = lab.lab._id;
    updateRequest.labName = lab.lab.name;
    this.blocked = true
    updateRequest.orderItems = this.selectedOrder.orderItems.filter(orderItem => { return orderItem.barcode != "0" && orderItem.barcode.length >= 8 && orderItem.orderItemStatus != "CANCEL" });
    this.orderListService.updateOrder(updateRequest).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.onDialogHide();
        this.displayDialog = false;
        //Load first 100 record after the material reception
        this.getOrders(0, 100, this.queryString, this.selectedFilter, this.searchedFilterBarcode);
        this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Order status updated', detail: 'Order recevied status updated successful' });
        console.log("updated order status:", results);
        this.loading = false
        this.blocked = false
      },
      error => {
        console.log(error);
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.loading = false
        this.blocked = false
      }
    );

  }

  /**
   *
   */
  updateSelectedOrderStatus() {

    this.loading = true
    console.log("Update selected material", this.selectedPlate, this.selectedPrimer);
    let selectedOrderItemIds = [];
    let orderItemData = [];
    let updateRequest = new OrderStatusUpdateRequest();

    this.selectedPlate.forEach(plate => {
      selectedOrderItemIds.push(plate.orderItemId);
      orderItemData.push(plate);
      updateRequest.orderItems = orderItemData.filter(orderItem => {
        return orderItem.barcode != 0 && orderItem.barcode.length >= 8 && !orderItem.stored && !orderItem.containerReceived && orderItem.orderItemStatus != 'CANCEL'
      });
    });

    this.selectedPrimer.forEach(primer => {
      selectedOrderItemIds.push(primer.orderItemId);
    });

    updateRequest.orderId = this.selectedOrder.orderId;

    let lab = JSON.parse(localStorage.getItem('lab'));
    updateRequest.labId = lab.lab._id;
    updateRequest.labName = lab.lab.name;
    updateRequest.orderItemIds = selectedOrderItemIds;

    this.orderListService.updateOrder(updateRequest).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.onDialogHide();
        this.displayDialog = false;
        this.orderItemChecked = [];
        this.selectedPlate = [];
        // Show first 100 orders update material reception
        this.getOrders(0, 100, this.queryString, this.selectedFilter, this.searchedFilterBarcode);
        this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Selected order status updated', detail: 'Selected Material recevied status updated successful' });
        console.log("updated selected order status:", results);
        this.loading = false
      },
      error => {
        console.log(error);
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.loading = false
      }
    );

  }

  /**
   * Hide the checkbox if
   * Sample is already stored in Genomics lab
   * Sample is already received before
   * @param sample
   */
  hiddenSampleIf(sample: OrderItem) {
    return sample.stored || sample.containerReceived || sample.wellType == "384-Well";
  }

  /**
   * Hide the checkbox if
   * Primer type is of Standard or Stored.
   * Primer is already received before.
   * @param primer
   */
  hiddenPrimerIf(primer: SequencingPrimer) {
    return primer.notreceivablePrimer || primer.materialReceived;
  }

  /**
   * Checks if a valid Barcode is present in the Grid
   */
  ifNoValidBarcodePresent() {
    let orderItems = [];
    let primers = [];

    if (this.selectedOrder != undefined || this.selectedOrder != null) {

      orderItems = this.selectedOrder.orderItems;
      primers = this.selectedOrder.sequencingPrimers;
    }

    let validOrderItems = [];
    let validPrimers = [];

    if (orderItems != undefined) {
      validOrderItems = orderItems.filter(orderItem =>
        (orderItem.barcode != undefined && orderItem.barcode != null && orderItem.barcode != "0" && orderItem.barcode != ""));
    }

    if (primers != undefined) {
      validPrimers = primers.filter(primer =>
        (primer.primerBarcode != undefined && primer.primerBarcode != null && primer.primerBarcode != "0" && primer.primerBarcode != ""));
    }
    // partial button is active if at least one valid barcode is present
    this.partialReceivedActive = validOrderItems.length == 0 && validPrimers.length == 0;
    return this.partialReceivedActive;
  }

  /**
   * enable receive all material button based when all the primers and samples have valid barcode
   * */
  ifAllSampleBarcodeValid() {
    let orderItems = [];
    let primers = [];

    if (this.selectedOrder != undefined || this.selectedOrder != null) {

      orderItems = this.selectedOrder.orderItems;
      primers = this.selectedOrder.sequencingPrimers;
    }

    let validOrderItems = [];
    let validPrimers = [];

    if (orderItems != undefined && orderItems != null) {
      validOrderItems = orderItems.filter(orderItem =>
        (orderItem.barcode != undefined && orderItem.barcode != null && orderItem.barcode != "0" && orderItem.barcode != "" && orderItem.barcode.length >= 8));
    }

    if (primers != undefined && primers != null) {
      validPrimers = primers.filter(primer =>
        (primer.primerBarcode != undefined && primer.primerBarcode != null && primer.primerBarcode != "0" && primer.primerBarcode != "" || primer.primerType === "Standard" || primer.primerType === "ToBeSynthesized" || primer.primerType === "Stored"));
    }
    let allReceivedActive = false;
    if (validOrderItems != null && validOrderItems != undefined && validPrimers != null && validPrimers != undefined && orderItems != null && orderItems != undefined && orderItems && primers != undefined && primers != null)
      allReceivedActive = validOrderItems.length == orderItems.length && validPrimers.length == primers.length && orderItems.length != 0 && primers.length != 0;
    return allReceivedActive;
  }

  //Method to velidate Sample barcode (Manually entered)
  validateSampleBarcode(orderId: string, barcode: string, sampleId: string, plateOrTube: string) {
    console.log("Validate Sample Barcode OrderId---- > ", orderId);
    console.log("Validate Sample Barcode Barcode---- > ", event);
    this.allDisabledSampleCheckBox(this.selectedOrder.orderItems);

    let orderRequest = new OrderPrintBarcode;

    orderRequest.orderId = orderId;
    orderRequest.barcode = barcode;

    //this.samplesIds.push(sampleId);

    let sampleTemplate = new SamplePrintTemplate;
    sampleTemplate.sampleObjectId = sampleId;
    sampleTemplate.plateOrTube = plateOrTube;

    let sampleTemplateList: SamplePrintTemplate[] = [];
    sampleTemplateList.push(sampleTemplate);
    orderRequest.samplesIds = sampleTemplateList;

    if (barcode != "" && barcode != null && barcode != undefined) { this.validateBarcode(orderRequest); }
    this.resetRequest();
  }


  //Method to velidate Primer barcode (Manually entered)
  validatePrimerBarcode(orderId: string, barcode: string, primerId: string) {
    console.log("Validate Primer Barcode OrderId---- > ", orderId);
    console.log("Validate Primer Barcode Barcode---- > ", event);

    this.allDisabledPrimerCheckBox(this.selectedOrder.sequencingPrimers);
    let orderRequest = new OrderPrintBarcode;

    orderRequest.orderId = orderId;
    orderRequest.barcode = barcode;

    this.primersIds.push(primerId);
    orderRequest.primersIds = this.primersIds;
    if (barcode != "" && barcode != null && barcode != undefined) { this.validateBarcode(orderRequest); }

    this.resetRequest();
  }

  //Want a return value from this function, so that we can identify in the respective
  //Funtions (whichever uesed this funtion) and we can set that value to 0
  // This method validates entered barcode
  validateBarcode(orderRequest: OrderPrintBarcode) {

    return this.orderListService.validateInputBarcode(orderRequest).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("validate barcode ----> " + results.data);

        if (results.data == false) {
          this.messagesService.addErrorMessage({ severity: 'warn', summary: 'Invalid bacode', detail: 'Barcode already exists or Invalid format' });
        } else {
          this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Valid', detail: 'Barcode saved successfully' });
        }
      },
      error => {
        console.log(error);
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    );
  }

  //Method to generate Samples barcode
  //Tube barcodes and Primer barcodes will be printed with CAB-A4+ printers
  //Plate barcodes are printed with TSC printers
  generateSingleSampleBarcode(orderId: string, sampleId: string, printerTemplate: string) {

    if (printerTemplate == 'Tube' && this.selectedTubePrinter == null) {
      this.messagesService.addErrorMessage({ severity: 'error', summary: 'Invalid Tube printer', detail: 'Please select a tube printer' });
      return;
    }

    let orderGenerateBarcodeReq = new OrderPrintBarcode;

    console.log("One sampleId : ---> " + sampleId);
    this.samplesIds.push(sampleId);

    orderGenerateBarcodeReq.orderId = orderId;
    let sampleTemplate = new SamplePrintTemplate;
    sampleTemplate.sampleObjectId = sampleId;
    sampleTemplate.plateOrTube = printerTemplate;

    let sampleTemplateList: SamplePrintTemplate[] = [];
    sampleTemplateList.push(sampleTemplate);
    orderGenerateBarcodeReq.samplesIds = sampleTemplateList;
    orderGenerateBarcodeReq.printerTemplate = printerTemplate;
    if (printerTemplate == 'Plate') {
      orderGenerateBarcodeReq.selectedPlatePrinter = this.selectedPlatePrinter;
      orderGenerateBarcodeReq.selectedPrinter = this.selectedPlatePrinter;
    }
    else if (printerTemplate == 'Tube' || printerTemplate == 'Primer') {
      orderGenerateBarcodeReq.selectedTubePrinter = this.selectedTubePrinter;
      orderGenerateBarcodeReq.selectedPrinter = this.selectedTubePrinter;
    } else {
      orderGenerateBarcodeReq.selectedPrinter = (printerTemplate == 'Plate' ? this.selectedPlatePrinter :
        ((printerTemplate == 'Tube' || printerTemplate == 'Primer') ? this.selectedTubePrinter : this.selectedDefaultPrinter))
    }

    this.generateBarcode(orderGenerateBarcodeReq);
    this.resetRequest();
  }

  //Method to generate Primers barcode
  //Tube barcodes and Primer barcodes will be printed with CAB-A4+ printers
  //Plate barcodes are printed with TSC printers
  generateSinglePrimerBarcode(orderId: string, primerId: string, printerTemplate: string) {

    if (printerTemplate == 'Primer' && this.selectedTubePrinter == null) {
      this.messagesService.addErrorMessage({ severity: 'error', summary: 'Invalid Tube printer', detail: 'Please select a tube printer to print primer' });
      return;
    }

    let orderGenerateBarcodeReq = new OrderPrintBarcode;

    console.log("One primerId : ---> " + primerId);
    this.primersIds.push(primerId);

    orderGenerateBarcodeReq.orderId = orderId;
    orderGenerateBarcodeReq.primersIds = this.primersIds;
    orderGenerateBarcodeReq.printerTemplate = printerTemplate;
    orderGenerateBarcodeReq.selectedTubePrinter = this.selectedTubePrinter;
    orderGenerateBarcodeReq.selectedPrinter = (printerTemplate == 'Plate' ? this.selectedPlatePrinter :
      ((printerTemplate == 'Tube' || printerTemplate == 'Primer') ? this.selectedTubePrinter : this.selectedDefaultPrinter))

    this.generateBarcode(orderGenerateBarcodeReq);
    this.resetRequest();
  }

  //Method to generate and Print all empty barcodes in one shot
  //Tube barcodes and Primer barcodes will be printed with CAB-A4+ printers
  //Plate barcodes are printed with TSC printers
  generateAndPrintAll(orderId: string) {

    if (this.selectedTubePrinter == null || this.selectedPlatePrinter == null) {
      this.messagesService.addErrorMessage({ severity: 'error', summary: 'Invalid Tube/Plate printer', detail: 'Please select a printer' });
      return;
    }

    console.log("OrderId : ---> " + orderId);
    let orderGenerateAndPrintBarcodeReq = new OrderPrintBarcode;
    orderGenerateAndPrintBarcodeReq.numberOfCopies = 1;
    let sampleTemplateList: SamplePrintTemplate[] = [];

    this.selectedOrder.orderItems.forEach(sample => {

      if (this.emptySampleBarcode(sample)) {

        let sampleTemplate = new SamplePrintTemplate;
        sampleTemplate.sampleObjectId = sample.sampleId;
        sampleTemplate.plateOrTube = sample.printerTemplate;
        sampleTemplateList.push(sampleTemplate);
        console.log("SampleId : ---> " + sample.sampleId);
      }
    });

    this.selectedOrder.sequencingPrimers.forEach(primer => {

      if (primer.primerType != 'Standard' && this.emptyPrimerBarcode(primer)) {
        this.primersIds.push(primer.primerId);
        console.log("primerId : ---> " + primer.primerId);
      }
    });

    orderGenerateAndPrintBarcodeReq.orderId = orderId;
    orderGenerateAndPrintBarcodeReq.samplesIds = sampleTemplateList;
    orderGenerateAndPrintBarcodeReq.primersIds = this.primersIds;
    orderGenerateAndPrintBarcodeReq.selectedPrinter = this.selectedDefaultPrinter;
    orderGenerateAndPrintBarcodeReq.selectedPlatePrinter = this.selectedPlatePrinter;
    orderGenerateAndPrintBarcodeReq.selectedTubePrinter = this.selectedTubePrinter;
    orderGenerateAndPrintBarcodeReq.printType = 'PRINT_ALL';

    this.generateBarcode(orderGenerateAndPrintBarcodeReq);
    this.resetRequest();

  }


  emptySampleBarcode(sample: OrderItem) {
    return sample.barcode == '0' || sample.barcode == '' || sample.barcode == null;
  }

  emptyPrimerBarcode(primer: SequencingPrimer) {
    return primer.primerBarcode == '0' || primer.primerBarcode == '' || primer.primerBarcode == null;
  }

  //Reset Arrays
  resetRequest() {
    this.samplesIds = [];
    this.primersIds = [];
  }


  //Get generated barcodes
  generateBarcode(orderGenerateAndPrintBarcodeReq: OrderPrintBarcode) {
    this.isGenerateClicked = true;
    this.loading = true
    this.orderListService.getGeneratedBarcode(orderGenerateAndPrintBarcodeReq).subscribe(
      results => {
        if (!results) {
          return;
        }
        if (results.data == true) {
          this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Generated', detail: 'Barcode generated and saved successfully' });
          this.getUpdatedOrderView(orderGenerateAndPrintBarcodeReq.orderId);
        }
        this.loading = false;
        this.isGenerateClicked = false;
      },
      error => {
        console.log(error);
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.loading = false;
        this.isGenerateClicked = false;
      }
    );
  }

  //Method to print input barcode
  //Tube barcodes and Primer barcodes will be printed with CAB-A4+ printers
  //Plate barcodes are printed with TSC printers
  printBarcode(barcode: string, printerTemplate: string) {

    console.log('Print ' + barcode + ' with ' + printerTemplate)

    if ((printerTemplate == 'Tube' || printerTemplate == 'Primer') && this.selectedTubePrinter == null) {
      this.messagesService.addErrorMessage({ severity: 'error', summary: 'Invalid tube printer', detail: 'Please select a tube printer' });
      return;
    }


    if (printerTemplate == 'Plate' && this.selectedPlatePrinter == null) {
      this.messagesService.addErrorMessage({ severity: 'error', summary: 'Invalid plate printer', detail: 'Please select a plate printer' });
      return;
    }

    let orderPrintBarcodeReq = new OrderPrintBarcode;
    orderPrintBarcodeReq.numberOfCopies = 1;
    orderPrintBarcodeReq.barcode = barcode;
    orderPrintBarcodeReq.selectedPrinter = (printerTemplate == 'Plate' ? this.selectedPlatePrinter :
      ((printerTemplate == 'Tube' || printerTemplate == 'Primer') ? this.selectedTubePrinter : this.selectedDefaultPrinter));

    console.log("Printer used --> ", orderPrintBarcodeReq.selectedPrinter.name);

    this.orderListService.printBarcode(orderPrintBarcodeReq).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("Order --> IsPrintSuccess --> ", results.data);
        if (results.data == true) {
          this.messagesService.addErrorMessage({ severity: 'success', summary: 'Successful', detail: 'Barcode Printed successfully' });
        } else {
          this.messagesService.addErrorMessage({ severity: 'error', summary: 'Failed', detail: 'Something went wrong' });
        }
      },
      error => {
        console.log(error);
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    );
  }



  getUpdatedOrderView(orderId: string) {
    console.log("Updated result ----- >", orderId);
    this.orderListService.getOrderView(orderId).subscribe(
      results => {
        if (!results) {
          return;
        }
        let order = results.data;
        this.selectedOrder.orderItems = order.orderItems;
        this.selectedOrder.sequencingPrimers = order.sequencingPrimers;
        /** should be removed once we are not remaining with the materials which exists in BB but processed in GATCLIMS */
        this.selectedOrder.sequencingPrimers.forEach(primer => {
          if (primer.primerType === "Stored" && (primer.storagePlateBarcode === "" || primer.storagePlateBarcode == null || primer.storagePlateBarcode == undefined))
            primer.isPresentInGatcLims = true
        })
        this.loading = false;
      },
      error => {
        console.log(error);
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.loading = false;
      }
    );
  }


  getSampleReceptionDefinition() {
    console.log("Getting Semple Reception Definition....");
    this.processStep = ProcessStep.SAMPLE_RECEPTION;
    this.carrierStatusService.getProcessStepDetails(this.processStep, this.selectedLab.lab).subscribe(
      results => {
        if (!results) {
          return
        }
        if (results.data) {
          this.carrierStateDetails = results.data;

          if (this.carrierStateDetails.printer && this.carrierStateDetails.printer.active) {
            //this.selectedTubePrinter = this.carrierStateDetails.printer;
            this.selectedPlatePrinter = this.carrierStateDetails.printer;
            this.selectedDefaultPrinter = this.carrierStateDetails.printer;
          }

        }

      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    )
  }


  //Get list of active printers for selected lab
  getListOfPrinters() {
    console.log("Getting List of printers....");
    this.isPrinterLoaded = true;
    this.carrierStatusService.getPrintersListWithTemplate(this.selectedLab.lab, true, 'Plate').subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("[Orders] Plate Printers List -> ", results.data);
        this.platePrintersList = results.data;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    )

    this.carrierStatusService.getPrintersListWithTemplate(this.selectedLab.lab, true, 'Tube').subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log("[Orders] Tube Printers List -> ", results.data);
        this.tubePrintersList = results.data;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    )
  }

  hiddenPrimerTypeIf(primer: SequencingPrimer) {
    if (primer.primerType)
      return primer.primerType == 'Standard';
  }

  //barcode validation  for sample:disable/enable check based on it.
  isInvalidSampleBarcode(sample: OrderItem): boolean {
    let flag: boolean;
    sample.barcode == null || sample.barcode == undefined || sample.barcode == "0" ||
      sample.barcode == "" || sample.barcode.length < 8 || sample.stored ||
      sample.containerReceived || sample.wellType == "384-Well" ? flag = true : flag = false;
    return flag;
  }

  //barcode validation  for primer:disable/enable check based on it.
  isInvalidPrimerBarcode(primer: SequencingPrimer): boolean {
    let flag: boolean;
    primer.primerBarcode == null || primer.primerBarcode == undefined || primer.primerBarcode == "0" ||
      primer.primerBarcode == "" || primer.primerBarcode.length < 8 ? flag = true : flag = false;
    return flag;
  }

  /*
  checks selection/dimissal of  header checkbox
  */
  onHeaderCheckboxToggle(event: any) {
    if (!event.checked) {
      this.orderItemChecked = [];
    } else {
      this.selectedOrder.orderItems.forEach(orderItem => {
        if (orderItem.barcode != "0" && orderItem.barcode.length >= 8 && orderItem.orderItemStatus != 'CANCEL') {
          this.orderItemChecked.push(orderItem);
        }
      })
    }
  }
  /*
  checks the selection of row
  */
  onRowSelect(event) {
    if (this.isInvalidSampleBarcode(event.data)) {
      return
    } else {
      this.orderItemChecked.push(event.data);
    }
  }

  /*
  checks the unchecking  of row checkbox
  */
  onRowUnselect(event) {
    if (this.isInvalidSampleBarcode(event.data)) {
      return
    } else {
      this.orderItemChecked.splice(this.orderItemChecked.indexOf(event.data), 1)
    }
  }

  /*
  if all sample rows are disabled/hidden then hide the header checkbox
  */
  allDisabledSampleCheckBox(orderItems: OrderItem[]) {
    this.orderItemDisabledChecked = [];
    orderItems.forEach(orderItem => {
      if (orderItem.stored || orderItem.containerReceived || this.isInvalidSampleBarcode(orderItem)) { this.orderItemDisabledChecked.push(orderItem); }
    })

  }

  /*
  if all primer rows are disabled/hidden then hide the header checkbox
  */
  allDisabledPrimerCheckBox(sequencingPrimers: SequencingPrimer[]) {
    this.sequencingPrimerDisabledChecked = [];
    sequencingPrimers.forEach(sequencePrimer => {
      if (this.hiddenPrimerIf(sequencePrimer) || this.isInvalidPrimerBarcode(sequencePrimer)) { this.sequencingPrimerDisabledChecked.push(sequencePrimer); }
    })

  }

  ifUnpurifiedMaterial(sample: OrderItem) {
    return 'UNPURIFIED_PCR' == sample.originalMaterialType || 'UNPURIFIED_PCR' == this.sampleType(sample) ||
      'LIQUID_CULTURE' == sample.originalMaterialType || 'LIQUID_CULTURE' == this.sampleType(sample) ||
      'ECOLI_COLONY' == sample.originalMaterialType || 'ECOLI_COLONY' == this.sampleType(sample) ||
      'CLONE' == sample.originalMaterialType || 'CLONE' == this.sampleType(sample);
  }

  sampleType(sample: OrderItem): string {
    return sample.sampleType != undefined || sample.sampleType != null ? sample.sampleType : ''
  }

  selectSearchOrder() {
    this.loading = true
    this.allDisabledSampleCheckBox(this.selectedOrder.orderItems);
    this.allDisabledPrimerCheckBox(this.selectedOrder.sequencingPrimers);
    if (!this.isPrinterLoaded) {
      this.getListOfPrinters();
      this.selectedTubePrinter = null;
      this.selectedPlatePrinter = null;
    }
    this.getSampleReceptionDefinition();
    this.loading = false;
    this.ifNoValidBarcodePresent();
  }

  onChange(sample) {
    let comment = new Comment(sample.sampleId, sample.comment);
    this.comments.push(comment);
  }

  onInternalCommentChange() {
    this.internalComment = this.selectedOrder.internalComment;
    this.isInternalCommentUpdateRequested = true;
  }

  onSupportCategoryChange() {
    this.selectedSupportCategory = this.selectedOrder.supportCategory;
    this.isSupportCategoryUpdateRequested = true;
  }
  /**
   * Check and send Reaction set state
   * @param state
   */
  getStateFromReactionSet(state: string) {
    if (state == "UNUSED")
      return "Place Reaction";
    else if (state == "CANCEL")
      return "Cancelled";
    else if (state == "ANALYSIS_COMPLETED")
      return "Complete";
    else
      return state;
  }

  /**
     * Convert quality to OK or Fail
     * @param state
     */
  getQualityFromReactionSet(quality: string) {
    if (quality != null && quality != undefined) {
      if (quality == 'PASSED')
        return 'OK';
      else
        return 'Fail';
    }
    return '';
  }

  repeatHiddenIf(state: string) {
    if (state == 'ANALYSIS_COMPLETED' || state == 'CANCEL')
      return false;
    return true;
  }

  cancelHiddenIf(state: string) {
    if (state == 'UNUSED')
      return false;
    return true;
  }

  onClose() {
    if (this.selectedReactionSetsToRepeat.length > 0 || this.selectedReactionSetsToCancel.length > 0) {
      this.confirmationService.confirm({
        message: 'Do you want to leave without updating the selected reactions?',
        header: 'Confirmation',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.index = 0;
          this.displayDialog = false;
          this.selectedReactionSetsToRepeat = [];
          this.selectedReactionSetsToCancel = [];
          this.selectedReactionSetsToUpdateProtocols = [];
          this.selectedReactionSetsToUpdateVolume = [];
          this.msgs = [{ severity: 'info', summary: 'Confirmed', detail: 'You have accepted' }];
        },
        reject: () => {

        }
      });
    }
    else {
      this.index = 0;
      this.displayDialog = false;
      this.selectedReactionSetsToRepeat = [];
      this.selectedReactionSetsToCancel = [];
      this.selectedReactionSetsToUpdateProtocols = [];
      this.selectedReactionSetsToUpdateVolume =[];
    }
  }

  getIcon(supportCategory: string) {
    if (supportCategory != null) {
      let selectCategory = this.supportCategories.find(category => category.value == supportCategory)
      return selectCategory.icon;
    }
  }
  onTabChange(event) {
    switch (event.index) {
      case 0: // Samples
        this.confirmSavingMaterialState()
        break
      case 1:
        this.findExpectedMaterials(this.selectedOrder)
        this.checkRecentUnsavedEntry()
        break
      case 2: // Scan
        this.confirmSavingMaterialState()
        this.orderListService.fetchAllPlatesForAnOrder(this.selectedOrder.orderId, this.selectedOrder.orderRef, this.selectedOrder.productionOrderIds).subscribe(
          results => {
            if (!results) {
              return;
            }
            this.plateUsageOrderData = results.data;

          },
          error => {
            let message = this.errorHandler.handleError(error);
            this.messagesService.addErrorMessage(message);
          }
        );
        break;
      case 3: // Plate Information
        this.confirmSavingMaterialState()
        this.reactionSetService.fetchReactionSetsToManage(this.selectedOrder.orderId).subscribe(

          results => {
            if (!results) {
              return;
            }
            this.reactionsManagerDTO = results.data;
            if (this.reactionsManagerDTO.length > 0) {
              this.enableUpdate = true;
            } else {
              this.enableUpdate = false;
            }
          },
          error => {
            let message = this.errorHandler.handleError(error);
            this.messagesService.addErrorMessage(message);
          }
        );
        this.getAllSamplesAndPrimer();
        break;
      case 4:
        this.getMaterialsForOrder(this.selectedOrder)
        break;
      default:
        break;
    }
    this.index = event;

  }
  confirmSavingMaterialState() {
    if (!this.noUnsavedEntry) {
      this.confirm()
    }
  }

  storeReactionSetIdsToBeCancelledOrRepeated(id: string, reactionSetIds: Array<string>) {

    let reactionSetId = reactionSetIds.filter(storedId => { return storedId === id })
    if (reactionSetId != null && reactionSetId != undefined && reactionSetId.length > 0) {
      var index = reactionSetIds.indexOf(reactionSetId[0]);
      reactionSetIds.splice(index, 1)
    }
    else {
      reactionSetIds.push(id);
    }
  }

  storeReactionSetIdsToBeUpdatedWithProtocol(id: string, reactionsetProtocolArray: Array<ReactionSetProtocol>, protocol: string) {
    let reactionSetProtocol = new ReactionSetProtocol();
    reactionSetProtocol.reactionSetId = id;
    reactionSetProtocol.protocol = protocol;
    reactionsetProtocolArray.push(reactionSetProtocol);
  }

  storeReactionSetIdsToBeUpdatedWithVolume(id: string, reactionsetVolumeArray: Array<ReactionSetUsedSampleVolume>, volume: number) {
    let reactionSetVolume = new ReactionSetUsedSampleVolume();
    let repeatedEntry :boolean = false;
    reactionSetVolume.reactionSetId = id
    reactionSetVolume.volume = volume
    reactionsetVolumeArray.forEach(ele=>{
      if(ele.reactionSetId == id) {
        ele.volume =volume;
        repeatedEntry = true;
      }
    })
    if(!repeatedEntry) {
    reactionsetVolumeArray.push(reactionSetVolume);
    }
  }
  onUpdate(orderId: string, id: string) {
    this.redoCancelReactionSetRequest.reactionSetsToBeCancelled = this.selectedReactionSetsToCancel;
    this.redoCancelReactionSetRequest.reactionSetsToBeRepeated = this.selectedReactionSetsToRepeat;
    this.redoCancelReactionSetRequest.reactionSetProtocolsToBeUpdated = this.selectedReactionSetsToUpdateProtocols;
    this.redoCancelReactionSetRequest.reactionSetVolumesToBeUpdated =this.selectedReactionSetsToUpdateVolume;
    this.redoCancelReactionSetRequest.orderId = orderId;
    this.redoCancelReactionSetRequest.genomicsOrderRef = id;
    if ((this.redoCancelReactionSetRequest.reactionSetsToBeCancelled != null && this.redoCancelReactionSetRequest.reactionSetsToBeCancelled.length > 0)
      || (this.redoCancelReactionSetRequest.reactionSetsToBeRepeated != null && this.redoCancelReactionSetRequest.reactionSetsToBeRepeated.length > 0)
      || (this.redoCancelReactionSetRequest.reactionSetProtocolsToBeUpdated != null && this.redoCancelReactionSetRequest.reactionSetProtocolsToBeUpdated.length > 0)
      || (this.redoCancelReactionSetRequest.reactionSetVolumesToBeUpdated != null && this.redoCancelReactionSetRequest.reactionSetVolumesToBeUpdated.length > 0)){
      this.loading = true;
      this.reactionSetService.updateReactionSetsWithRedoOrCancel(this.redoCancelReactionSetRequest).subscribe(
        results => {
          if (!results || !results.data) {
            return;
          }
          this.loading = false;
          this.reactionsManagerDTO = results.data;
          this.messagesService.addSuccessMessage({ severity: 'success', summary: 'ReactionSets Updated Successfully' });
          this.selectedReactionSetsToRepeat = [];
          this.selectedReactionSetsToCancel = [];
          this.selectedReactionSetsToUpdateProtocols = [];
          this.selectedReactionSetsToUpdateVolume =[];
        },
        error => {
          this.loading = false;
          let message = this.errorHandler.handleError(error);
          this.messagesService.addErrorMessage(message);

        }
      );
    }
  }

  // update protocol for all reactionsets of the order
  setProtocolForAllReactionSets() {
    this.selectedReactionSetsToUpdateProtocols = [];
    // Loop for each sample of the order
    for (var i = 0; i < this.reactionsManagerDTO.length; i++) {
      //Loop in each reactionset of the sample
      for (var j = 0; j < this.reactionsManagerDTO[i].reactions.length; j++) {
        this.reactionsManagerDTO[i].reactions[j].reactionOptionProtocol = this.setProtocol;
        //set id and protocol to the array to update
        let reactionSetProtocol = new ReactionSetProtocol();
        reactionSetProtocol.reactionSetId = this.reactionsManagerDTO[i].reactions[j].id;
        reactionSetProtocol.protocol = this.setProtocol;
        this.selectedReactionSetsToUpdateProtocols.push(reactionSetProtocol);
      }
    }
  }

  setUsedVolumeForAllReactionSets() {
    this.selectedReactionSetsToUpdateVolume =[];
    for (var i = 0; i < this.reactionsManagerDTO.length; i++) {
      for (var j = 0; j < this.reactionsManagerDTO[i].reactions.length; j++) {
        this.reactionsManagerDTO[i].reactions[j].usedSampleVolume = this.usedSampleVolume;
        let reactionSetVolume = new ReactionSetUsedSampleVolume();
        reactionSetVolume.reactionSetId = this.reactionsManagerDTO[i].reactions[j].id;
        reactionSetVolume.volume = this.usedSampleVolume;
        this.selectedReactionSetsToUpdateVolume.push(reactionSetVolume);
      }
    }
  }

  onPrimerHeaderCheckboxToggle(event: any) {
    //debugger
    if (!event.checked) {
      this.sequencingPrimerCheck = [];
    } else {
      this.selectedOrder.sequencingPrimers.forEach(primer => {
        if (primer.primerBarcode != "0" && primer.primerBarcode.length >= 8 && primer.orderItemStatus != 'CANCEL') {
          this.sequencingPrimerCheck.push(primer);
        }
      })
    }
  }
  /*
  checks the selection of row
  */
  onRowSelectOfPrimer(event) {
    if (this.isInvalidPrimerBarcode(event.data)) {
      return
    } else {
      this.sequencingPrimerCheck.push(event.data);
    }
  }
  /*
  checks the unchecking  of row checkbox
  */
  onRowUnselectOfPrimer(event) {
    if (this.isInvalidPrimerBarcode(event.data)) {
      return
    } else {
      this.sequencingPrimerCheck.splice(this.sequencingPrimerCheck.indexOf(event.data), 1)
    }
  }
  cancelAllSelectedMaterial() {
    if (confirm("Do you really want to cancel the selection? This can't be undone!")) {
      this.loading = true
      console.log("cancel selected material", this.selectedPlate, this.selectedPrimer);
      let selectedOrderItemIds = [];

      let cancelRequest = new CancelOrderItemRequest();
      let orderItemData = [];
      this.selectedPlate.forEach(plate => {
        console.log("plate", plate.orderItemId)
        selectedOrderItemIds.push(plate.orderItemId);
        console.log("plate data ----> ", plate)
        orderItemData.push(plate);
        cancelRequest.orderItems = orderItemData.filter(orderItem => {
          return orderItem.barcode != 0 && orderItem.barcode.length >= 8 && !orderItem.stored && !orderItem.containerReceived && orderItem.orderItemStatus == 'New'
        });
      });
      let orderItemPrimerData = [];
      this.selectedPrimer.forEach(primer => {
        console.log("primer", primer.orderItemId);
        selectedOrderItemIds.push(primer.orderItemId);
        console.log("plate data ----> ", primer)
        orderItemPrimerData.push(primer);
        cancelRequest.sequencingPrimers = orderItemPrimerData.filter(orderItem => {
          return orderItem.primerBarcode != 0 && orderItem.primerBarcode != null && !orderItem.stored && !orderItem.containerReceived &&
            orderItem.primerType != "Standard" && orderItem.orderItemStatus == 'New'
        });
      });
      cancelRequest.orderId = this.selectedOrder.orderId;

      cancelRequest.orderItemIds = selectedOrderItemIds;
      this.orderListService.cancelMaterial(cancelRequest).subscribe(
        results => {
          if (!results) {
            return;
          }
          this.displayDialog = false;
          // Show first 100 orders update material reception
          this.orderItemChecked = [];
          this.selectedPlate = [];
          this.getOrders(0, 100, this.queryString, this.selectedFilter, this.searchedFilterBarcode);
          this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Selected order status updated', detail: 'Selected Materials cancelled successfully' });
          console.log("Cancelled selected materials :", results);
          this.loading = false
        },
        error => {
          console.log(error);
          let message = this.errorHandler.handleError(error);
          this.messagesService.addErrorMessage(message);
          this.loading = false
        }
      );
    }
  }

  onFilerClick(event: string) {
    this.queryString = event;
    this.countOrders(this.queryString);
    this.getOrders(0, 100, this.queryString, this.selectedFilter, this.searchedFilterBarcode);
  }

  setSelectedFilter(event) {
    this.selectedFilter = event;
  }

  setSearchedFilterBarcode(event) {
    this.searchedFilterBarcode = event;
  }
  nonEmptyProcessingOption(order: Order) {
    return order.processingOption != undefined && order.processingOption != null && order.processingOption != "";
  }

  onRushAction(order: Order) {
    this.rushFlagUpdateRequest = new RushFlagUpdateRequest();
    this.rushFlagUpdateRequest.genomicsOrderRef = order.orderRef;
    this.rushFlagUpdateRequest.isRush = order.isRush;
    this.rushFlagUpdateRequest.orderStatus = order.orderStatus;
    this.orderListService.updateRushFlag(this.selectedLab.lab._id, this.rushFlagUpdateRequest).subscribe(results => {
      if (!results.data)
        return;
    },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    )
  }

  onQcOverruleAction(order: Order) {
    this.qcOverRuleUpdateRequest = new QCOverRuleUpdateRequest();
    this.qcOverRuleUpdateRequest.genomicsOrderRef = order.orderRef;
    this.qcOverRuleUpdateRequest.isQCOverRule = order.isQCOverRule;
    this.orderListService.updateQcOverRuleFlag(this.selectedLab.lab._id, this.qcOverRuleUpdateRequest).subscribe(results => {
      if (!results.data)
        return;
    },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    )
  }

  onNxpUkAction(order: Order) {
    this.nxpUkUpdateRequest = new NxpUkUpdateRequest();
    this.nxpUkUpdateRequest.genomicsOrderRef = order.orderRef;
    this.nxpUkUpdateRequest.isNxpUk = order.isNxpUk;
    this.orderListService.updateNxpUkFlag(this.selectedLab.lab._id, this.nxpUkUpdateRequest).subscribe(results => {
      if (!results.data)
        return;
    },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    )
  }

  onDxPAction(order: Order) {
    this.dxpUpdateRequest = new DxPUpdateRequest();
    this.dxpUpdateRequest.genomicsOrderRef = order.orderRef;
    this.dxpUpdateRequest.isDxP = order.isDxP;
    this.orderListService.updateDxpFlag(this.selectedLab.lab._id, this.dxpUpdateRequest).subscribe(results => {
      if (!results.data)
        return;
    },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    )
  }
  // Check if the Barcode contains SEQ in it.
  isSEQBarcode(barcode: string) {
    if (barcode.includes('SEQ')) {
      return true;
    }
    return false;
  }

  // Get all QC reports related to the barcode in tthe Order screen.
  fetchQCReoprtsByBarcode(barcode: string) {
    console.log('Barcode:' + barcode);
    this.qualityreportListService.getQualityReport(QCReportFilter.ALL_REPORTS, barcode, null).subscribe(
      result => {
        {
          if (!result && !result.data) {
            return;
          }
          if (result.data.length < 1) {
            this.messagesService.addSuccessMessage(
              { severity: 'error', summary: 'Record not found', detail: 'No QC Reports were found for plate ' + barcode });
            return;
          }
          this.qcReports = result.data;
          const qcReportMap = new Map();
          this.qcReports.forEach(report => {
            qcReportMap.set(report.reportType, report);
          });
          const keys = Array.from(qcReportMap.keys());


          this.qcReportViewMap = new Map();
          let reportGroupedByType = [];

          keys.forEach(keyInMap => {
            reportGroupedByType = [];
            this.qcReports.forEach(report => {
              if (keyInMap === report.reportType) {
                reportGroupedByType.push(report);
              }
            });
            this.qcReportViewMap.set(keyInMap, reportGroupedByType);
          });
        }
      },
      error => {
        console.log(error);
        const message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      });
  }

  // Show the clicked QC report in detail
  showQCReport(reportId: string) {
    this.eurofinsControl = [];
    this.qcReportDetail = new QcReportDetailDTO();
    this.qcreportDetailService.getQCReportService(reportId).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.qcReportDetail = results.data;
        (!this.qcReportDetail.qcParams) ?
          this.eurofinsControl = [] : this.qcReportDetail.qcParams.forEach(element => {
            if (element != null) {
              this.eurofinsControl.push(element);
            }
          });
        this.displayQCReportDialog = true;
        this.id = reportId;
      },
      error => {
        const message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    );
  }

  // close the QC Reports dialog
  hideDialog() {
    this.displayQCReportDialog = false;
  }
  // Fetch the Plate details for given plate barcode
  showPlateOverview(plateBarcode: string) {
    this.carrierSearch.getContainerDataByBarcode(plateBarcode, this.selectedLab.lab).subscribe(
      results => {
        const cntrList: Container[] = results.data;
        if (cntrList.length === 0) {
          this.messagesService.addErrorMessage({
            severity: 'error', summary: 'Plate Not Found', detail: 'No plates found for selected barcode'
          });
        }
        this.selectedContainer = cntrList[0];
        this.isCarrier = this.selectedContainer.containerType != null ?
          this.selectedContainer.containerType === ContainerType.CARRIER ? true : false : true;
        this.plateView = true;
      },
      error => {
        console.log(error);
        const errMessage = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(errMessage);
      }
    );
  }

  closeDialog($event) {
    this.selectedContainer = null;
    this.plateView = false;
  }

  findExpectedMaterials(order: Order) {
    this.receivedMaterials = []
    this.expectedMaterials = []
    this.materialWithoutBarcodeCount = 0
    if (order && order.orderItems) {
      order.orderItems.forEach(sample => {
        if (sample.wellType == "384-Well" || sample.orderItemStatus === "CANCEL") { return }
        else if (sample.barcode == null || sample.barcode == undefined || sample.barcode == "") { this.materialWithoutBarcodeCount++ }
        else if (sample.containerReceived || (sample.stored && !sample.isPresentInGatcLims)) {
          this.receivedMaterials.push(new ScanableMaterial(sample.barcode, sample.sampleName, sample.containerReceived, sample.stored, sample.orderItemId, MaterialType.Sample, null, <OriginalMaterialType>sample.originalMaterialType))
        }
        else
          this.expectedMaterials.push(new ScanableMaterial(sample.barcode, sample.sampleName, sample.containerReceived, sample.stored, sample.orderItemId, MaterialType.Sample, null, <OriginalMaterialType>sample.originalMaterialType));
      })
      if (order.sequencingPrimers) {
        order.sequencingPrimers.forEach(primer => {
          if (!primer.isPresentInGatcLims && primer.primerType === "Stored" || primer.primerType === "Standard") { return }
          else if (primer.materialReceived)
            this.receivedMaterials.push(new ScanableMaterial(primer.primerBarcode, primer.primerName, primer.materialReceived, primer.stored, primer.orderItemId, MaterialType.Primer, primer.primerType, null))
          else if (this.isInvalidPrimerBarcode(primer)) { this.materialWithoutBarcodeCount++ }
          else { this.expectedMaterials.push(new ScanableMaterial(primer.primerBarcode, primer.primerName, primer.materialReceived, primer.stored, primer.orderItemId, MaterialType.Primer, primer.primerType, null)) }
        })
      }
    }
    this.cacheSavedMaterial = this.receivedMaterials.length;
    this.cacheReceivedMaterials = []
    this.receivedMaterials.forEach(material => this.cacheReceivedMaterials.push(material));
  }

  ifExpectedMaterialsAreNotEmpty() {
    return this.expectedMaterials.length != 0 || (this.expectedMaterials.length == 0 && this.receivedMaterials.length == 0) || (this.expectedMaterials.length == 0 && this.materialWithoutBarcodeCount != 0)
  }

  isReceptionCompleteDisabled() {
    return this.ifExpectedMaterialsAreNotEmpty() || this.isScanTableDisabled()
  }

  checkRecentUnsavedEntry() {

    this.noUnsavedEntry = this.cacheSavedMaterial == this.receivedMaterials.length;
    this.cacheReceivedMaterials = []
    this.receivedMaterials.forEach(material => this.cacheReceivedMaterials.push(material));
  }

  validateIfCanBeMovedToSource(event) {
    let material = event.items[0].materialReceived ? event.items[0] : null;
    if (material) {
      this.receivedMaterials = this.cacheReceivedMaterials
      let index = this.expectedMaterials.indexOf(material)
      this.expectedMaterials.splice(index, 1)
      this.msgs = [{ severity: 'warn', detail: 'Received Material can not be moved' }]
    }

    this.checkRecentUnsavedEntry();
  }

  valdidateIfAllCanBeMoved(event) {
    let alreadyReceivedItems = event.items.filter(item => item.materialReceived)
    if (alreadyReceivedItems && alreadyReceivedItems.length > 0) {
      this.findExpectedMaterials(this.selectedOrder)
    }
    this.checkRecentUnsavedEntry();
  }

  saveScannedMaterialState() {
    let scannedOrderItemIds: string[] = this.receivedMaterials.filter(material => !material.materialReceived)
      .map(material => material.orderItemId)

    if (!scannedOrderItemIds || scannedOrderItemIds.length == 0) {
      return
    }

    let updateRequest = new OrderStatusUpdateRequest()
    updateRequest.orderId = this.selectedOrder.orderId
    let lab = JSON.parse(localStorage.getItem('lab'));
    updateRequest.labId = lab.lab._id;
    updateRequest.labName = lab.lab.name;
    updateRequest.orderItemIds = scannedOrderItemIds
    updateRequest.orderItems = this.selectedOrder.orderItems
      .filter(orderItem => scannedOrderItemIds.includes(orderItem.orderItemId))
    this.blocked = true
    this.orderListService.updateOrder(updateRequest).subscribe(
      results => {
        if (!results) {
          return
        }

        this.findExpectedMaterials(this.selectedOrder);
        this.checkRecentUnsavedEntry()
        this.onDialogHide();
        this.displayDialog = false;
        this.orderItemChecked = [];
        this.selectedPlate = [];
        // Show first 100 orders update material reception
        this.getOrders(0, 100, this.queryString, this.selectedFilter, this.searchedFilterBarcode);
        this.blocked = false
        this.messagesService.addSuccessMessage({ severity: 'success', summary: 'Selected order status updated', detail: 'Selected Material recevied status updated successful' });

      }, error => {
        this.checkRecentUnsavedEntry()
        this.blocked = false
      })
  }

  confirm() {
    let answer = window.confirm('Want to save Scanned samples?')
    if (answer) {
      this.saveScannedMaterialState()
    }
  }

  onEnterAfterScan(materialBarcode: string) {
    this.materialBarcode = "";
    let barcodeWithoutEmptySpace = materialBarcode.replace(/\s/g, "").trim()
    let materialToBeRemovedFromExpectedMaterials;
    this.expectedMaterials.forEach(material => {
      if (material.materialBarcode === barcodeWithoutEmptySpace) {
        this.receivedMaterials.unshift(material);
        this.checkRecentUnsavedEntry();
        materialToBeRemovedFromExpectedMaterials = material;
      }
    })
    if (materialToBeRemovedFromExpectedMaterials) {
      /* inserts the latest barcode and removes the old barcodes if size>2 */
      this.latestScannedBarcodes.unshift(barcodeWithoutEmptySpace);
      if (this.latestScannedBarcodes.length > 2) {
        this.latestScannedBarcodes.pop();
      }
      var index = this.expectedMaterials.indexOf(materialToBeRemovedFromExpectedMaterials);
      this.expectedMaterials.splice(index, 1);
    }
    else if (this.isReceivedMaterial(materialBarcode)) {
      this.msgs = [{ severity: 'warn', detail: materialBarcode + ' is already received' }]
    }
    else {
      this.msgs = [{ severity: 'warn', detail: materialBarcode + ' does not exist in this order' }]
    }
  }

  isReceivedMaterial(materialBarcode: string) {
    let isReceived = false;
    this.receivedMaterials.forEach(material => {
      if (material.materialBarcode === materialBarcode) {
        isReceived = true;
      }
    })
    return isReceived;
  }

  isScanTableDisabled() {
    return this.selectedOrder && this.selectedOrder.orderStatus !== 'New'
  }
  isSynthesized(primerType: string) {
    return "ToBeSynthesized" === primerType;
  }

  isEnclosed(primerType: string) {
    return "Enclosed" === primerType;
  }

  isSample(materialType: MaterialType) {
    return MaterialType.Sample === materialType;
  }

  isPurified(originalMaterialType: OriginalMaterialType) {
    return OriginalMaterialType.PURIFIED_DNA === originalMaterialType;
  }

  isUnpurifiedOrClone(originalMaterialType: OriginalMaterialType) {
    return OriginalMaterialType.UNPURIFIED_PCR === originalMaterialType || OriginalMaterialType.CLONE === originalMaterialType;
  }

  notPurifiedOrUnpurified(originalMaterialType: OriginalMaterialType) {
    return OriginalMaterialType.UNPURIFIED_PCR != originalMaterialType && OriginalMaterialType.CLONE != originalMaterialType && OriginalMaterialType.PURIFIED_DNA != originalMaterialType;
  }

  getCssForReceivedMaterials(material: ScanableMaterial) {
    if (material.materialReceived) {
      return { 'font-style': 'italic', 'color': '#099419', 'font-weight': 'bold' }
    }
  }

  getMaterialsForOrder(order: Order) {
    this.loading = true
    this.orderListService.getMaterialsForOrder(order.orderRef).subscribe(
      result => {
        if (!result && !result.data) {
          this.loading = false;
          return;
        }
        this.loading = false;
        this.materialResponsePerOrder = result.data;
      },
      error => {
        this.loading = false;
        let message = this.errorHandler.handleError(error);
        console.log(message);
        this.messagesService.addErrorMessage(message);

      }
    );
  }

  ifSample(materialResponsePerOrder: MaterialResponsePerOrder) {
    return materialResponsePerOrder.materialName != null && materialResponsePerOrder.materialName != undefined && materialResponsePerOrder.materialName != "" && materialResponsePerOrder.originalMaterialType != null && materialResponsePerOrder != undefined && materialResponsePerOrder.originalMaterialType != "";
  }

  ifPrimer(materialResponsePerOrder: MaterialResponsePerOrder) {
    return materialResponsePerOrder.primerType != null && materialResponsePerOrder.primerType != undefined && materialResponsePerOrder.primerType != "" && materialResponsePerOrder.materialName != null && materialResponsePerOrder.materialName != undefined && materialResponsePerOrder.materialName != "";
  }

  getStorage(materialResponsePerOrder: MaterialResponsePerOrder) {
    if (materialResponsePerOrder.storagePosition != null && materialResponsePerOrder.storagePosition != undefined && materialResponsePerOrder.storagePosition != "")
      return materialResponsePerOrder.storagePosition
    else
      return ""
  }
  createReaction() {
    this.loading = true
    this.reactionSetRequestDTO = new ReactionSetRequestDTO();
    this.reactionSetRequestDTO.sample=this.selectedSampleforReaction;
    this.reactionSetRequestDTO.lab=this.selectedLab.lab;
    this.reactionSetRequestDTO.primers=[]
    this.reactionSetRequestDTO.primers.push(this.selectedPrimerforReaction);
    this.orderListService.createReactionSet(this.reactionSetRequestDTO,this.selectedOrder.orderId).subscribe(
      results => {
        if (results && results.data) {
          this.messagesService.addSuccessMessage({
            severity: 'success', summary: 'Success!',
            detail: results.data
          });
          this.loading = false;
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.loading = false
      }
    );

  }
  isCreateReactionDisabled() {
    return(!((this.selectedPrimerforReaction && this.selectedPrimerforReaction != null)&&(this.selectedSampleforReaction && this.selectedSampleforReaction != null)));
  }
  getAllSamplesAndPrimer(){
    this.orderListService.getAllSamplesAndPrimersForOrder(this.selectedOrder.orderId).subscribe(
      result=>{
        if(result && result.data) {
          this.sampleAndPrimerResponseDTO = result.data;
          this.samplesSelectionList = [];
          this.selectedSampleforReaction=null;
          this.sampleAndPrimerResponseDTO.samples.forEach(sample=>{
            if(sample.barcode && sample.barcode!=null && sample.barcode != '') {
              this.samplesSelectionList.push({label:sample.sampleName.concat(" - ").concat(sample.barcode),value: sample})
            }
          })
          this.primersSelectionList=[];
          this.selectedPrimerforReaction=null;
          this.sampleAndPrimerResponseDTO.primers.forEach(primer=>{
          if(primer.primerType == "Standard" || (primer.barcode!=null && primer.barcode != '')) {
            this.primersSelectionList.push({label:primer.primerName,value: primer})
          }
        });
      }
    },
    error => {
      let message = this.errorHandler.handleError(error);
      this.messagesService.addErrorMessage(message);
    }
    );
  }

}
